import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from "primeng/api";
import { HelpersService } from '../../../../services/helpers.service'
import { RentalsService } from '../../../../services/rentals.service'
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-add-edit-accessory-categories',
  templateUrl: './add-edit-accessory-categories.component.html',
  styleUrls: ['./add-edit-accessory-categories.component.scss'],
  providers: [MessageService]
})
export class AddEditAccessoryCategoriesComponent implements OnInit {

  @Input() category;
  @Input() messageService;
  public busy: boolean = false;

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    public modal: NgbActiveModal,
    private translate: TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
  }

  valid() {
    return this.category.categoryName && this.category.categoryName.length > 0;
  }

  saveCategory() {
    if (this.category.id) {
      this.rentalsService.updateRentalAccessoryCategory({ ...this.category, allowBringYourOwn: !this.category.forceSelection ? false : this.category.allowBringYourOwn }).subscribe(res => {
        this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.rentals.category.category_updated', { categoryName: this.category.categoryName }) });
        this.modal.close(this.category);
      });
    } else {
      const data = {
        categoryName: this.category.categoryName,
        defaultPartnerID: this.helpersService.getPartnerId(),
        isActive: true,
        forceSelection: this.category.forceSelection,
        allowBringYourOwn: !this.category.forceSelection ? false : this.category.allowBringYourOwn,
      };
      this.rentalsService.addRentalAccessoryCategory(data).subscribe(res => {
        this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.rentals.category.category_added', { categoryName: this.category.categoryName }) });
        this.modal.close(this.category);
      });
    }
  }

  removeCategory() {
    if (this.category.id) {
      this.confirmationService.confirm({
        rejectLabel: this.translate.instant('general.no'),
        acceptLabel: this.translate.instant('general.yes'),
        message: this.translate.instant('bikeshop.rentals.category.confirm_remove_category', { categoryName: this.category.categoryName }),
        accept: () => {
          const data = { ...this.category, isActive: false };
          this.rentalsService.updateRentalAccessoryCategory(data).subscribe(res => {
            this.messageService.add({ life: 5000, detail: this.translate.instant('bikeshop.rentals.category.category_removed', { categoryName: this.category.categoryName }) });
            this.modal.close(this.category);
          });
        },
        reject: () => {

        }
      });
    }
  }

}
